import React from 'react';

import { PageTitle } from '../../Text';
import HomeButton from '../HomeButton';

const SessionMessage = () => (
  <div className="modal">
    <div className="error-content">
      <PageTitle>
        System Error
      </PageTitle>
      <p>
        <span>
          There is a problem with the website. Please start again.
        </span>
      </p>
      <HomeButton />
    </div>
  </div>
);

export default SessionMessage;
